import React, { useState, useEffect } from "react";
import { Container, Typography, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Project from "../project/Project";
import Dataset from "../dataset/Dataset";
import { fetchProjectsApi } from "../../api/project";
import { addProjects, GetProjects } from "../../indexDB/utils/project";
import { fetchDatasetsApi } from "../../api/dataset";
import { addDataset, getDataset } from "../../indexDB/utils/dataset";
import { syncDatapoints } from "../../indexDB/utils/datapoint";
import { useLocation } from "react-router-dom";

const HomePage = ({ handleLogout, setDataset }) => {
  const location = useLocation();
  const { selectedProjectProp, selectedDatasetProp } = location.state || {};

  const [dropdown1Value, setDropdown1Value] = useState("");
  const [dropdown2Value, setDropdown2Value] = useState("");
  const [isButton2Disabled, setIsButton2Disabled] = useState(true);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedDataset, setSelectedDataset] = useState(null);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const [projects, setProjects] = useState([]);
  const [datasets, setDatasets] = useState([]);
  const [openSyncDialog, setOpenSyncDialog] = useState(false);
  const [dataSyncingComplete, setDataSyncingComplete] = useState(false);
  const [projectsFetched, setProjectsFetched] = useState(0);

  const history = useNavigate();

  const handleDropdown1Change = async (event) => {
    setDropdown1Value(event.target.value);
    setIsButton2Disabled(!event.target.value || !dropdown2Value);
    setSelectedProject(event.target.value.id);
    setDropdown2Value("");
    setIsButton2Disabled(true);
    localStorage.setItem("project", event.target.value.name);
    localStorage.setItem("project_id", event.target.value.id);
    await handleSetDatasetAfterProject();
  };

  const handleSetDatasetAfterProject = async () => {
    try {
      const offlineDatasets = await getDataset();
      setDatasets(offlineDatasets);
      if (selectedDatasetProp && offlineDatasets) {
        const selectedDataset = offlineDatasets?.find(dataset => dataset.uuid === selectedDatasetProp);
        setDropdown2Value(selectedDataset)
        setSelectedDataset(selectedDataset)
        setDataset(selectedDataset)
        setIsButton2Disabled(selectedProject && selectedDataset)
      }
    } catch (error) {
      handleLogout("Failed to set dataset from project selection !!");
    }
  };

  const handleDropdown2Change = (event) => {
    setDropdown2Value(event.target.value);
    setIsButton2Disabled(!dropdown1Value || !event.target.value);
    setSelectedDataset(event.target.value);
    setDataset(event.target.value);
    localStorage.setItem("dataset_id", event.target.value.id);
  };

  const handleButton1Click = () => {
    history("/new-entry");
  };

  const fetchProjects = async () => {
    try {
      const indexDBProjects = await GetProjects();
      setProjects(indexDBProjects);
      if (selectedProjectProp && indexDBProjects) {
        const selectedProject = indexDBProjects?.find(project => project.name === selectedProjectProp)
        if (selectedProject) {
          handleSetDatasetAfterProject();
          setDropdown1Value(selectedProject || null)
          setSelectedProject(selectedProject?.id || null)
        } 
      }

    } catch (error) {
      console.error("Error fetching data from the indexDB");
    }
  };

  const prepopulateProjectAndDataset = () => {
    setSelectedProject(selectedProjectProp);
    setSelectedDataset(selectedDatasetProp);
    setDropdown1Value(selectedProjectProp);
    setDropdown2Value(selectedDatasetProp);
    console.log("selectedDatasetProp:",selectedDatasetProp);
    setIsButton2Disabled(selectedProject === null);
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        minHeight: `calc(100vh - 64px)`,
        width: "100%",
        padding: { xs: "12px", sm: "100px" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          textAlign: "center",
          width: { xs: "100%", sm: "75%" },
        }}
      >
        <Project
          projects={projects}
          dropdown1Value={dropdown1Value}
          handleDropdown1Change={handleDropdown1Change}
        />

        <Dataset
          selectedProject={selectedProject}
          datasets={datasets}
          dropdown2Value={dropdown2Value}
          handleDropdown2Change={handleDropdown2Change}
        />

        <Box sx={{ flex: { xs: 1, md: "unset" } }} />

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            width: "100%",
            justifyContent: "flex-end",
            padding: "4px",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            disabled={isButton2Disabled}
            onClick={handleButton1Click}
            sx={{ marginBottom: { xs: "unset", md: "1" } }}
          >
            <Typography
              variant="body1"
              sx={{ fontWeight: "bold", padding: "4px" }}
            >
              START DATA COLLECTION
            </Typography>
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default HomePage;
